/** `url` cut at its first `?`. */
export const urlWithoutQuery = (url: string): string => {
  const queryStart = url.indexOf('?');
  return queryStart < 0 ? url : url.slice(0, queryStart);
};
